// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"HomeRecentSearch-module__ellipsis___zZWym","bg":"HomeRecentSearch-module__bg___6ouPm"};